import clsx from 'clsx';
import { AuthInterface } from 'interfaces';
import { Table } from "semantic-ui-react";
import { ui } from 'services';
import CustomButton from './button';
export default function CustomTable({ tableHeader, tableData, className, onDelete, onEdit, refetch, setRefetch, overrideHeader, highlight, highlightField, loading }: any) {
    return (
        <div className={clsx("flex gap-4 flex-col lg:flex-row overflow-auto", className)}>
            <div className="w-full">
                <Table ui="true" single="true" line="true" unstackable selectable inverted sortable padded className={`${overrideHeader} no-border-header overflow-x-auto`}>
                    <Table.Header className="sticky top-0"
                        style={{ background: "#000000", zIndex: "20" }}
                    >
                        <Table.Row>
                            {tableHeader?.map((header: any, i: number) => {
                                return <Table.HeaderCell key={`head-${i}`}>
                                    {header.fieldName}
                                </Table.HeaderCell>
                            })}
                        </Table.Row>
                    </Table.Header>


                    <Table.Body className="relative">
                        {
                            loading ? <div className="absolute text-white top-[100px] mx-auto self-center justify-center w-full">
                                <div className="loader mx-auto text-center"></div>
                            </div> :
                                tableData?.map((data: any, i: number) => {
                                    return (
                                        <Table.Row key={`row-${i}`} className={`${highlightField && highlight.includes(data[highlightField]) && "table-active-row"}`}>
                                            {tableHeader?.map((header: any, i: number) => {
                                                let renderData = header.fieldKey !== 'All' ? data[header.fieldKey] : data;
                                                if (header.fieldKey)
                                                    return (
                                                        <Table.Cell key={`header-${i}`} className={header.className}>
                                                            {header.render ? header.render(renderData, data.C) : renderData}
                                                        </Table.Cell>
                                                    )
                                            })}
                                            {(onEdit || onDelete) && <Table.Cell className="">
                                                <div className="md:grid md:grid-cols-2 w-full h-full ml-auto text-center justify-center gap-2 max-w-[200px]">
                                                    {onEdit &&
                                                        <CustomButton
                                                            className="my-1 min-w-[80px] max-w-[100px]"
                                                            color="yellow"
                                                            onClick={async () => { await onEdit(data) }}
                                                        >Edit</CustomButton>}
                                                    {onDelete &&
                                                        <CustomButton
                                                            color="red"
                                                            className="my-1 min-w-[80px] max-w-[100px]"
                                                            onClick={() => ui.confirmAction("Confirm delete",
                                                                <div className="text-left mb-2 text-lg">
                                                                    Please type <em>confirm</em> to confirm you action.
                                                                </div>,
                                                                "default",
                                                                async () => {
                                                                    await onDelete(data?.[AuthInterface.identity]);
                                                                    setRefetch(!refetch);
                                                                })}
                                                        >Delete</CustomButton>}
                                                </div>
                                            </Table.Cell>}
                                        </Table.Row>
                                    )
                                })}
                        <Table.Row>
                            {tableHeader?.map((header: any, i: number) => {
                                return (
                                    <Table.Cell key={"empty" + i}>
                                    </Table.Cell>
                                )
                            })}
                        </Table.Row>
                        {tableData?.length <= 0 && <Table.Row className={`absolute w-full h-full mx-auto justify-center items-center`}>
                            <Table.Cell className="mx-auto text-center block w-full no-result">
                                <div className="text-bold mt-2">
                                    No records found
                                </div>
                            </Table.Cell>
                        </Table.Row>}
                    </Table.Body>
                </Table>
            </div>
        </div >
    )
}